var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.026 0H2.974C1.885 0 1 .841 1 1.875v11.25C1 14.159 1.885 15 2.974 15h21.052C25.115 15 26 14.159 26 13.125V1.875C26 .841 25.115 0 24.026 0zm0 1.25c.04 0 .077.004.114.01l-9.91 6.277c-.382.242-1.078.242-1.46 0L2.86 1.26a.693.693 0 01.114-.01h21.052zM2.316 13.125c0 .345.295.625.658.625h21.052c.363 0 .658-.28.658-.625V2.418L14.96 8.577c-.41.259-.935.388-1.46.388-.525 0-1.05-.13-1.46-.388l-9.724-6.16v10.708z",
    fill: "#414042"
  })));
}

export default SvgEnvelope;